import moment from 'moment'

export const dateRangePickerConfig = {
    linkedCalendars: false,
    minDate: '2023-01-01',
    maxDate: moment().format('YYYY-MM-DD'),
    maxSpan: {
        days: 365,
    },
    opens: 'left',
    showDropdowns: true,
    localeData: {
        firstDay: 1,
        format : 'dd mmm yyyy',
    },
}